import React, { useState } from 'react';
import { useAuth } from '../auth/AuthContext';
import StatusBanner, { Status } from '../components/StatusBanner';

const Login: React.FC = () => {
  const { login } = useAuth();
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [busy, setBusy] = useState(false);
  const [status, setStatus] = useState<Status>(null);

  const submit = async (e: React.FormEvent) => {
    e.preventDefault();
    try {
      setBusy(true);
      setStatus(null);
      await login(username, password);
      // No redirect: the router renders the console as soon as the context
      // has a user.
    } catch (error) {
      // The server answers the same way for a wrong username, a wrong
      // password and a disabled account, so this message stays vague on
      // purpose -- being specific would confirm which usernames exist.
      setStatus({ kind: 'error', text: (error as Error).message });
      setPassword('');
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-100 px-4">
      <div className="w-full max-w-sm">
        <h1 className="text-center text-2xl font-bold text-gray-900">SoR Platform</h1>
        <p className="mt-1 text-center text-sm text-gray-600">Sign in to the console</p>

        {/* The only <form> in the app, so Enter submits -- a login that
            ignores the Enter key is a small daily annoyance. */}
        <form onSubmit={submit} className="mt-6 bg-white shadow rounded-lg px-4 py-5 sm:p-6 space-y-4">
          <div>
            <label htmlFor="username" className="block text-sm font-medium text-gray-700">Username</label>
            <input
              id="username"
              name="username"
              autoComplete="username"
              autoFocus
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              className="mt-1 block w-full border-gray-300 rounded-md shadow-sm focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
            />
          </div>
          <div>
            <label htmlFor="password" className="block text-sm font-medium text-gray-700">Password</label>
            <input
              id="password"
              name="password"
              type="password"
              autoComplete="current-password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              className="mt-1 block w-full border-gray-300 rounded-md shadow-sm focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
            />
          </div>

          <StatusBanner status={status} className="mt-2" />

          <button
            type="submit"
            disabled={busy || !username || !password}
            className="w-full inline-flex justify-center rounded-md border border-transparent shadow-sm px-4 py-2 bg-indigo-600 text-sm font-medium text-white hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 disabled:opacity-50 disabled:cursor-not-allowed"
          >
            {busy ? 'Signing in...' : 'Sign in'}
          </button>
        </form>
      </div>
    </div>
  );
};

export default Login;
